import AddRemoveFromGroupPlay from '../../../../lessons/lessonactions/add-remove-from-group-play/AddRemoveFromGroupPlay';
import { useStudentContext } from '../../../context/MyStudentContextProvider';
import Logger from '../../../../../utils/Logger';

export default function MyStudentAddRemoveFromGroupPlay({
  lesson,
}) {
  const { myStudentDomain } = useStudentContext();
  const { lessonData } = myStudentDomain.domainData;

  return (
    <AddRemoveFromGroupPlay
      lesson={lesson}
      onSaveSuccess={async (updatedLesson) => {
        Logger.isDebugMode({
          UPDATED_LESSON: updatedLesson,
        });
        myStudentDomain.updateLessons([...lessonData.lessons], lessonData.included, lessonData.filter);
      }}
    />
  );
}
